import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { CONTACT } from "../data/content";

export default function InstagramFloatButton() {
  return (
    <motion.a
      href={CONTACT.instagram}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="instagram-float"
      aria-label="Follow Kalpavriksha on Instagram"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.05 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.96 }}
      className="grid place-items-center w-11 h-11 rounded-full text-white bg-gradient-to-br from-[#f9ce34] via-[#ee2a7b] to-[#833ab4] shadow-[0_6px_20px_rgba(238,42,123,0.4)] hover:opacity-95 transition-opacity duration-300"
    >
      <Instagram className="w-5 h-5 shrink-0" strokeWidth={2.25} />
    </motion.a>
  );
}
